<template>
  <div class="pt-3">
    <Loader v-if="!onboardingUsers || onboardingUsers.length == 0" />
    <div class="dashboard__container--body">
          
          <vue-good-table
              :columns="columns"
              :rows="onboardingUsers"
               styleClass="vgt-table condensed"
              :search-options="{
                enabled: true,
                placeholder: 'Search this table',
              }"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 25,
              }"
              
            >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'onboardingStarted'">
                <span v-if="props.row.onboardingStarted">{{formatDate(props.row.onboardingStarted)}}</span>
              </span>
              <span v-else-if="props.column.field == 'link'">
                <router-link :to="`/users/` + props.row.id" target="_blank">
                  <i class="fas fa-external-link ml-2 mr-2"></i>
                </router-link>
              </span>
              <span v-else-if="props.column.field == 'jesSkills'">
                <input type="checkbox" v-model.trim="props.row.jesSkills" id="esSkills" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesFaceTime'">
                <input type="checkbox" v-model.trim="props.row.jesFaceTime" id="jesFaceTime" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesInterview'">
                <input type="checkbox" v-model.trim="props.row.jesInterview" id="jesInterview" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesScreenshot'">
                <input type="checkbox" v-model.trim="props.row.jesScreenshot" id="jesScreenshot" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesBackground'">
                <input type="checkbox" v-model.trim="props.row.jesBackground" id="jesBackground" class="ml-3" @change="orderPremium(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesBackgroundPassed'">
                <input type="checkbox" v-model.trim="props.row.jesBackgroundPassed" id="jesBackgroundPassed" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesDrug'">
                <input type="checkbox" v-model.trim="props.row.jesDrug" id="jesDrug" class="ml-3" @change="orderDrug(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesDrugPassed'">
                <input type="checkbox" v-model.trim="props.row.jesDrugPassed" id="jesDrugPassed" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesOnboard'">
                <input type="checkbox" v-model.trim="props.row.jesOnboard" id="jesOnboard" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesOnboarded'">
                <input type="checkbox" v-model.trim="props.row.jesOnboarded" id="jesOnboarded" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesI9Verified'">
                <input type="checkbox" v-model.trim="props.row.jesI9Verified" id="jesI9Verified" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesPrivateGroup'">
                <input type="checkbox" v-model.trim="props.row.jesPrivateGroup" id="jesPrivateGroup" class="ml-3" @change="updateRow(props.row)" />
              </span>
              <span v-else-if="props.column.field == 'jesComplete'">
                <input type="checkbox" v-model.trim="props.row.jesComplete" id="jesComplete" class="ml-3" @change="updateRow(props.row)" />
              </span>

              
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
    </div>
  </div>
</template>




<script>
import * as moment from 'moment'
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
import router from '@/router'
const fb = require('../../firebaseConfig.js')

export default {
  name: 'onboardingEmployees',
  data: () => ({
    columns: [
      {
        label: 'Started',
        field: 'onboardingStarted',
        width: '120px',
      },
      {
        label: '',
        field: 'link',
        width: '48px',
        sortable: false
      },
      {
        label: 'First Name',
        field: 'firstName',
        width: '120px'
      },
      {
        label: 'Last Name',
        field: 'lastName',
        width: '120px'
      },
      {
        label: 'email',
        field: 'email',
        sortable: false
      },
      {
        label: 'phone',
        field: 'phone',
        width: '120px',
        sortable: false
      },
      {
        label: 'city',
        field: 'address.city',
        width: '120px',
      },
      {
        label: 'state',
        field: 'address.state',
        width: '60px',
      },
      {
        label: 'Has Job Skills',
        field: 'jesSkills',
        width: '120px',
      },
      {
        label: 'Interviewed',
        field: 'jesFaceTime',
        width: '120px',
      },
      {
        label: 'Passed Interview',
        field: 'jesInterview',
        width: '120px',
      },
      {
        label: 'I9 Screenshot',
        field: 'jesScreenshot',
        width: '120px',
      },
      {
        label: 'Background Ordered',
        field: 'jesBackground',
        width: '120px',
      },
      {
        label: 'Background Passed',
        field: 'jesBackgroundPassed',
        width: '120px',
      },
      {
        label: 'Drug Ordered',
        field: 'jesDrug',
        width: '120px',
      },
      {
        label: 'Drug Passed',
        field: 'jesDrugPassed',
        width: '120px',
      },
      {
        label: 'Everee Initiated',
        field: 'jesOnboard',
        width: '120px',
      },
      {
        label: 'I9 Verified',
        field: 'jesI9Verified',
        width: '120px',
      },
      {
        label: 'Everee Complete',
        field: 'jesOnboarded',
        width: '120px',
      },
      {
        label: 'Job Group',
        field: 'jesPrivateGroup',
        width: '120px',
      },
      {
        label: 'Complete/Remove',
        field: 'jesComplete',
        width: '120px',
      },
    ],
  }),
  created () {
    this.$store.dispatch("getOnboardingUsers") 
  },
  computed: {
    ...mapState(['currentUser', 'userProfile', 'onboardingUsers']),
  },
  components: {
    Loader,
  },
  methods: {
    async orderPremium(row) {
      let check = {
        orderedBy: this.userProfile.firstName + ' ' + this.userProfile.lastName,
        userId: this.row.id,
        user: this.row,
        type: 'Premium',
        status: 'Requested'
      }
      await fb.backgroundChecksCollection.add(check)
      fb.usersCollection.doc(this.user.id).update({
        jesBackground: true
      })
    },
    async orderDrug(row) {
      let check = {
        orderedBy: this.userProfile.firstName + ' ' + this.userProfile.lastName,
        userId: this.row.id,
        user: this.row,
        type: 'Drug',
        status: 'Requested'
      }
      await fb.backgroundChecksCollection.add(check)
      fb.usersCollection.doc(this.user.id).update({
        jesDrug: true
      })
    },
    async updateRow(row) {
      console.log(row)
      await fb.usersCollection.doc(row.id).update(row)
    },
    onRowClick(params) {
      let url = `/users/` + params.row.id
      console.log(url)
      router.push(url)
    },
    formatDate(q) {
      if(q) {
        const postedDate = new Date(q.seconds) * 1000;
        return moment(postedDate).format('MMMM Do YYYY, hh:mm a')
      } else {
        return null
      }
    },
  },
  beforeDestroy() {
    this.$store.dispatch("clearOnboardingUsers")
  }
}
</script>